import Page from "../../../layout/Page/Page";
import PageWrapper from "../../../layout/PageWrapper/PageWrapper";
import { CommonSurveySettingsList } from "./Common/CommonSurveySettingsList";

const SurveySettingsPage = () => {
    return (
        <PageWrapper title='Configuração do Questionários'>
            <Page container='fluid'>
                <div className='row h-100'>
                    <div className='col-12'>
                        <CommonSurveySettingsList />
                    </div>
                </div>
            </Page>
        </PageWrapper>
    );
};

export default SurveySettingsPage;